export default __webpack_public_path__ + "static/media/bph.28cede58.jpg";